module.exports = require("@wildboar/x500/src/lib/collections/matchingRules");